import { useEffect, useRef } from 'react'

import { BillingElements } from '../billing-elements'

export interface BillingCheckoutInlineProps {
  elementContext: BillingElements
  className?: string
}

export function BillingCheckoutInline({ elementContext, className }: BillingCheckoutInlineProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const hasLoadedRef = useRef(false)

  useEffect(() => {
    if (!containerRef.current || hasLoadedRef.current) return

    elementContext.mount(containerRef.current)
    hasLoadedRef.current = true
    return () => {
      hasLoadedRef.current = false
    }
  }, [elementContext])

  return <div ref={containerRef} className={className} />
}
